import React, { Fragment } from 'react';
import { useEffect, useState } from 'react';
import { Card, Form, Table, Button } from 'react-bootstrap';
import { MdBrightness5 } from "react-icons/md";
import { formatoMonto } from '../../../../../common/Formatos';
import AddPago from './pago';


const Implicados = ({ cfg_form, implicados }) => {
    const [sowModalPago, setShowModalPago] = useState(false);
    const [montosBool, setMontosBool] = useState([]);
    const [implicadoSelect, setImplicadoSelect] = useState(null);

    useEffect(() => {
        if (implicados) {
            const auxBools = [];
            implicados.forEach(implicado => auxBools.push(implicado.montoApagar && implicado.montoApagar > 0 ? true : false));

            setMontosBool(auxBools);
        }
    }, [implicados])

    const handleModalPago = (impl) => {
        setShowModalPago(true);
        setImplicadoSelect(impl);
    }

    return (
        <Fragment>
            <Card className='my-4'>
                <Card.Header style={{ backgroundColor: 'rgb(176 175 196)', color: '#3a3a8d', fontSize: '17px', fontWeight: '600' }}>
                {cfg_form && cfg_form["modalconsultacierre-grillaimplicados-title"]}
                </Card.Header>

                <Card.Body className="customCard">
                    <Table striped className="customTable">
                        <thead>
                            <tr>
                                <th style={{ textAlign: 'center' }}>{cfg_form && cfg_form["modalconsultacierre-grillaimplicados-id"]}</th>
                                <th style={{ textAlign: 'center' }}>{cfg_form && cfg_form["modalconsultacierre-grillaimplicados-nombre"]}</th>
                                <th style={{ textAlign: 'center' }}>{cfg_form && cfg_form["modalconsultacierre-grillaimplicados-tipoimpl"]}</th>
                                <th style={{ textAlign: 'center' }}>{cfg_form && cfg_form["modalconsultacierre-grillaimplicados-patente"]}</th>
                                <th style={{ textAlign: 'center' }}>{cfg_form && cfg_form["modalconsultacierre-grillaimplicados-estado"]}</th>
                                <th style={{ textAlign: 'center' }}>{cfg_form && cfg_form["modalconsultacierre-grillaimplicados-fecestado"]}</th>
                                <th style={{ textAlign: 'center' }}>{cfg_form && cfg_form["modalconsultacierre-grillaimplicados-aplicapago"]}</th>
                                <th style={{ textAlign: 'center' }}>{cfg_form && cfg_form["modalconsultacierre-grillaimplicados-mtopagar"]}</th>
                                <th style={{ textAlign: 'center' }}>{cfg_form && cfg_form["modalconsultacierre-grillaimplicados-seguro"]}</th>
                                <th style={{ textAlign: 'center' }}>{cfg_form && cfg_form["modalconsultacierre-grillaimplicados-cia"]}</th>
                                <th style={{ textAlign: 'center' }}></th>
                            </tr>

                        </thead>
                        <tbody>
                            {implicados?.map((implicado, index) => (
                                <tr key={index}>
                                    <td style={{ textAlign: 'center' }}>{implicado.idImplicado}</td>
                                    <td style={{ textAlign: 'center' }}>{implicado.nombreImplicado}</td>
                                    <td style={{ textAlign: 'center' }}>{implicado.glosaBienImplicado}</td>
                                    <td style={{ textAlign: 'center' }}>{implicado.patenteImplicado}</td>
                                    <td style={{ textAlign: 'center' }}>{implicado.estadoImplicado}</td>
                                    <td style={{ textAlign: 'center', width: '10%' }}>{implicado.fechaEstadoImplFormat}</td>
                                    <td style={{ textAlign: 'center' }}>
                                        <Form.Check
                                            disabled
                                            checked={montosBool[index] ? montosBool[index] : false}
                                        />
                                    </td>
                                    <td style={{ textAlign: 'center' }}>{formatoMonto(implicado.montoApagar)} {implicado.monedaIngreso}</td>
                                    <td style={{ textAlign: 'center' }}>{implicado.seguroImplicado}</td>
                                    <td style={{ textAlign: 'center' }}>{implicado.ciaImplicado}</td>
                                    <td style={{ textAlign: 'right' }}>
                                        <Button disabled={!montosBool[index]} variant='opciones me-md-2' size='sm' onClick={() => handleModalPago(implicado)}>
                                            <MdBrightness5 size={20} />
                                        </Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                    {implicados?.length === 0 &&
                        <span style={{ display: 'inherit', textAlign: 'center' }}>No hay registros encontrados.</span>
                    }
                </Card.Body>
            </Card>

            <AddPago
                showModal={sowModalPago}
                setShowModal={setShowModalPago}
                implicado={implicadoSelect?.idImplicado}
            />

            <style type='text/css'>
                {`
                    .customCard {
                        padding-top: 0;
                        padding-left: 0;
                        padding-right: 0;
                    }
                    .customHeaderCard {
                        background-color: rgb(176 175 196);
                        color: #3a3a8d;
                        font-size: 17px;
                        font-weight: 600
                    }
                    .customTable > thead {
                        color: white; 
                        background-color: rgb(114, 139, 176);
                    }
                    .customTable > thead > tr > th {
                        padding: 20px 0;
                    }
                `}
            </style>
        </Fragment>
    )
}

export default Implicados;